import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700 ring-1 ring-accent-200">
              <i className="ri-question-line" />
              吃瓜指南
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">关于看料站，你想知道的</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于更新节奏、频道筛选、热度算法与追更方法，这里整理了最常见的疑问。还有不清楚的，欢迎通过下方联系方式与我们交流。
            </p>
            <a
              href="#about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-secondary-600"
            >
              联系与反馈
              <i className="ri-chat-3-line" />
            </a>
          </div>

          <div className="space-y-3">
            {faqItems.map((item) => {
              const isOpen = open === item.id;
              return (
                <div
                  key={item.id}
                  className={`overflow-hidden rounded-2xl border transition ${
                    isOpen ? 'border-primary-200 bg-background-100/60' : 'border-background-200/80 bg-background-100/40'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : item.id)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3 text-sm font-semibold text-foreground-950 md:text-base">
                      <span
                        className={`grid h-6 w-6 shrink-0 place-items-center rounded-md text-xs font-bold ${
                          isOpen ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
                        }`}
                      >
                        {String(item.id).padStart(2, '0')}
                      </span>
                      {item.q}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line shrink-0 text-lg text-foreground-400 transition-transform ${
                        isOpen ? 'rotate-180 text-primary-600' : ''
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 pl-16 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}